var option_webview_default = {
  "option": "ohYps",
  "user_choice": "oN-U8",
  "check": "_6J2Y1",
  "image": "VVxHV",
  "input": "kxzN-",
  "title": "_7YNcl",
  "centered": "R-9jg",
  "with_result": "eEc4S",
  "list": "_0-KxD",
  "with_image": "TNwfV",
  "progress": "FhOYy",
  "progress_value": "eocny",
  "label": "MmfCL",
  "cta": "JHOyI",
  "adornment_icon": "_6s8yv",
  "remove": "_7WQQr",
  "removeButton": "heFlh",
  "removeButtonIcon": "r2VCB",
  "overlay": "Q4nKi",
  "shown": "cVUtl",
  "dark": "sOuh3",
  "spinner": "_9wIjO",
  "spin": "Zc30w",
  "grid": "yj6uK"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
